
<template>
  <div>
    <div
      class="
        h-screen
        flex
        w-full
        bg-img
        vx-row
        no-gutter
        items-center
        justify-center
      "
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <div class="text-center">
          <img
            class="image-responsive textcenter admin_logo mb-8"
            src="@/assets/images/logo/hobi_logo.png"
          />
        </div>

        <vx-card>
          <div slot="no-body" class="page-bg-color p-6">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2 inner_image">
                <img
                  src="@/assets/images/full-pages/Login.png"
                  class="mx-auto"
                />
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">{{ $t("labels.login") }}</h4>
                    <p>{{ $t("strings.login_account") }}</p>
                  </div>
                  <form @submit.prevent="login()" autocomplete="off">
                    <div>
                      <vs-input
                        name="email"
                        icon-no-border
                        autocomplete="off"
                        icon="icon icon-user"
                        icon-pack="feather"
                        :label-placeholder="$t('labels.email')"
                        v-model="email"
                        class="w-full"
                        v-validate="'required|email'"
                      />
                      <span class="text-danger text-sm">{{
                        errors.first("email")
                      }}</span>

                      <div class="password-field">
                        <vs-input
                          :type="passwordfieldtype"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          :label-placeholder="$t('labels.password')"
                          v-model="password"
                          class="w-full mt-8 password-field"
                          maxlength="20"
                          v-validate="{
                            required: true,
                            min: 8,
                            max: 20,
                            regex:
                              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                          }"
                        />
                        <button
                          type="button"
                          @click="switchVisibility"
                          :class="
                            passwordfieldtype == 'password'
                              ? 'eyeclose'
                              : 'eyeopen'
                          "
                          style="cursor: pointer"
                        ></button>
                      </div>
                      <span class="text-danger text-sm">{{
                        errors.first("password")
                      }}</span>
                      <div class="vx-row mt-6">
                        <div class="vx-col sm:w-1/2 w-full login_center">
                          <router-link :to="{ name: 'ForgotPassword' }">{{
                            $t("labels.forget_password")
                          }}</router-link>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                          <vs-button
                            :disabled="button_loading"
                            id="user-login"
                            button="submit"
                            class="
                              float-right
                              vs-component vs-button
                              float-right
                              px-4
                              w-full
                              md:w-auto
                              mb-1
                              sm:mt-3
                              md:mt-0
                              md:mb-0
                              vs-button-primary vs-button-filled
                            "
                            >{{ $t("labels.login_button") }}</vs-button
                          >
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      email: "",
      password: "",
      max: 20,
      hasVisiblePassword: true,
      passwordfieldtype: "password",
    };
  },
  mounted() {
    this.setValidationMessage();
    if (localStorage.getItem("authToken")) {
      this.$router.push("/admin/Dashboard");
    }
    if (localStorage.getItem("reset-password-visited")) {
      localStorage.removeItem("reset-password-visited");
    }
    if (localStorage.getItem("change-password")) {
      localStorage.removeItem("change-password");
    }
  },

  methods: {
    login() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader(true, "#user-login");
          let input = {
            email: this.email,
            password: this.password,
          };
          axios
            .post("admin/login", input)
            .then((response) => {
              let data = response.data.data;
              this.button_loader(false, "#user-login");
              this.$vs.notify({
                text: response.data.message,
                color: "success",
                position: "top-right",
              });
              let token = data.token;
              localStorage.setItem("authToken", token);
              this.$store.dispatch("updateAuthToken", token);
              let userInfo = {
                name: data.name,
                email: data.email,
                role: data.role,
              };
              localStorage.setItem("user", JSON.stringify(userInfo));
              this.$store.dispatch("updateUser", userInfo);
              this.$router.push({ name: "AdminDashboard" });
            })
            .catch((e) => {
              this.showError(e, "#user-login");
            });
        }
      });
    },
    switchVisibility() {
      this.passwordfieldtype =
        this.passwordfieldtype === "password" ? "text" : "password";
    },
  },
};
</script>
